// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__uk1P9","breadcrumbs-seperator":"Breadcrumbs_breadcrumbs-seperator__ujlHI"};